import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const workOrderList = createAsyncThunk('workOrder/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `work_order`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'asset_service_id': data?.asset_service_id,
                'date': data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const workOrderDetails = createAsyncThunk('workOrder/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `work_order/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delWorkOrder = createAsyncThunk('workOrder/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `work_order/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addWorkOrder = createAsyncThunk('workOrder/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'work_order',
            data: {
                "premise_id": data?.values?.premise_id,
                "asset_service_id": data?.values?.asset_service_id,
                "job_card_id": data?.values?.job_card_id,
                "vendor_id": data?.values?.vendor_id,
                "assigned_id": data?.values?.assigned_id || null,
                "fdate": data?.values?.fdate && moment(data?.values?.fdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "tdate": data?.values?.tdate && moment(data?.values?.tdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "remark": data?.values?.remark,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateWorkOrder = createAsyncThunk('workOrder/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'work_order',
            data: {
                "work_order_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "asset_service_id": data?.values?.asset_service_id,
                "job_card_id": data?.values?.job_card_id,
                "vendor_id": data?.values?.vendor_id,
                "assigned_id": data?.values?.assigned_id || null,
                "fdate": data?.values?.fdate && moment(data?.values?.fdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "tdate": data?.values?.tdate && moment(data?.values?.tdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "remark": data?.values?.remark,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateWorkOrderStatus = createAsyncThunk('workOrder/updateStatus', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'work_order_status',
            data: {
                "work_order_id": data?.work_order_id,
                "status": data?.status,
                "remark": data?.remark || '',
                ...(data?.fdate ? {
                    "fdate": moment(data.fdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                } : {}),
                ...(data?.tdate ? {
                    "tdate": moment(data.tdate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const assignWorkOrder = createAsyncThunk('workOrder/assign', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'work_order_assign',
            data: {
                "work_order_id": data?.work_order_id,
                "assigned_id": data?.assigned_id,
                "assigned_remark": data?.assigned_remark || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const workOrder = createSlice({
    name: 'workOrder',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(workOrderList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(workOrderDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    }
})

export default workOrder.reducer;